import { all } from 'redux-saga/effects';

import transactions from './reports';
import reportsFinancing from './reportsFinancing';
import slips from './reportsSlips';

function* watch() {
  yield all([
    transactions.saga.watch(),
    reportsFinancing.saga.watch(),
    slips.saga.watch(),
  ]);
}

export default {
  watch,
};
